import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Button, Tab } from "@mui/material";
import React, { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import EmailTemplate from "../EmailTemplate/EmailTemplate";
import { set } from "date-fns";
import EmailTemplateHome from "../EmailTemplate/EmailTemplateHome";
import EmailHome from "../Email/EmailHome";

export default function EmailTab({ theme, user, permissionConfig }) {
    const [selectedTab, setSelectedTab] = useState("emails");

    const handleChangeTab = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <>
            <TabContext value={selectedTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                        onChange={handleChangeTab}
                        aria-label="email tabs"
                        sx={{
                            "& .MuiTab-root": {},
                            "& .MuiTab-root.Mui-selected": {
                                color: theme.palette.tabSelected.main,
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: theme.palette.tabSelected.main,
                            },
                        }}
                    >
                        <Tab label="Emails" value="emails" />
                        <Tab label="Templates" value="templates" />
                    </TabList>
                </Box>
                <TabPanel value="emails" sx={{ p: 0 }}>
                    <EmailHome
                        theme={theme}
                        user={user}
                        permissionConfig={permissionConfig}
                    />
                </TabPanel>
                <TabPanel value="templates" sx={{ p: 0 }}>
                    <EmailTemplateHome
                        theme={theme}
                        user={user}
                        permissionConfig={permissionConfig}
                    />
                </TabPanel>
            </TabContext>
        </>
    );
}
